<template>
  <div class="view-privacy">
    <v-row justify="center">
      <v-col cols="12" md="10" lg="8">
        <v-card class="elevation-12">
          <v-toolbar
            color="primary"
            tile
            dark
            flat>
            <v-toolbar-title>
              {{ $t('privacy.title') }}<br>
              <span class="caption">{{ $t('privacy.subtitle') }}</span>
            </v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <v-card-text>
            <p>
              <strong>{{ $t('privacy.sections.a.title') }}</strong><br>
              <span v-html="$t('privacy.sections.a.content')"></span>
            </p>

            <p>
              <strong>{{ $t('privacy.sections.b.title') }}</strong><br>
              <span v-html="$t('privacy.sections.b.content')"></span>
            </p>

            <p>
              <strong>{{ $t('privacy.sections.c.title') }}</strong><br>
              <span v-html="$t('privacy.sections.c.content')"></span>
            </p>

            <p>
              <strong>{{ $t('privacy.sections.d.title') }}</strong><br>
              <span v-html="$t('privacy.sections.d.content')"></span>
            </p>

            <p>
              <strong>{{ $t('privacy.sections.e.title') }}</strong><br>
              <span v-html="$t('privacy.sections.e.content')"></span>
            </p>

            <p>
              <strong>{{ $t('privacy.sections.f.title') }}</strong><br>
              <span v-html="$t('privacy.sections.f.content')"></span>
            </p>

            <p>
              <strong>{{ $t('privacy.sections.g.title') }}</strong><br>
              <span v-html="$t('privacy.sections.g.content')"></span>
            </p>

            <p>
              <strong>{{ $t('privacy.sections.h.title') }}</strong><br>
              <span v-html="$t('privacy.sections.h.content')"></span>
            </p>

            <p>
              <strong>{{ $t('privacy.sections.i.title') }}</strong><br>
              <span v-html="$t('privacy.sections.i.content')"></span>
            </p>

            <p>
              <strong>{{ $t('privacy.sections.j.title') }}</strong><br>
              <span v-html="$t('privacy.sections.j.content')"></span>
            </p>

            <p>
              <strong>{{ $t('privacy.sections.k.title') }}</strong><br>
              <span v-html="$t('privacy.sections.k.content')"></span>
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'Privacy',
  data: () => ({
    //
  }),
};
</script>

<style lang="scss" scoped>
@import '@/styles/global.scss';

.view-privacy {
  padding-top: 2rem;
}

// Toglie il limite di altezza della toolbar e permette al testo di andare a capo
.v-card {
  header::v-deep {
    height: auto !important;

    .v-toolbar__content {
      height: auto !important;

      .v-toolbar__title {
        white-space: normal !important;
      }
    }
  }
}
</style>
